module.exports = {
  /**
   * This is a simple wrapper of i18Next that is loaded from `index.html` in a imperative way.
   * @param translateKey
   * @returns {*}
   */
  t: translateKey => window.i18next && window.i18next.t ? window.i18next.t(translateKey) : ''
};


/** WEBPACK FOOTER **
 ** ./src/services/i18nextWrapper.js
 **/